<template>
  <div class="app-container">
    <div>
      <div style="padding: 10px">
        <el-button type="primary" style="margin-left: 4px" @click="newAdd" :disabled="!canWrite">新增</el-button>
        <el-button type="primary" style="margin-left: 4px" @click="openPage" :disabled="Status === 2 || !canWrite">单据选择</el-button>
        <el-button type="primary" style="margin-left: 4px" @click="save" :disabled="Status === 2 || !canWrite">保存</el-button>
        <el-button type="primary" style="margin-left: 4px" @click="handleDelete" :disabled="!isSave || Status === 2 || !canWrite">删除</el-button>
        <el-button type="primary" style="margin-left: 4px" @click="reView" v-if="Status !== 2" :disabled="!isSave || !canReview">审核</el-button>
        <el-button type="primary" style="margin-left: 4px" @click="cancelReView" v-if="Status === 2" :disabled="!isSave || !canReview">弃审</el-button>
        <el-dropdown style="margin-left: 4px">
          <el-button type="primary" :disabled="!isSave"> 联查<i class="el-icon-arrow-down el-icon--right"></i> </el-button>
          <el-dropdown-menu slot="dropdown" style="margin-left: 4px">
            <el-dropdown-item class="dropdown-item" @click.native="goJump(1)">加工单</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
        <el-button type="primary" style="margin-left: 4px" :disabled="!isSave" @click="onPrint(data)">打印</el-button>
        <el-button type="primary" @click="openSetField">明细字段</el-button>
      </div>
      <el-form :model="data" ref="form" :inline="true" :line-form="true" label-width="80px" status-icon>
        <el-row style="margin-top: 18px">
          <el-form-item label="单据日期:" required label-width="100px">
            <span class="not-edit" v-if="Status === 2">{{ data.DocDate }}</span>
            <el-date-picker v-else v-model="data.DocDate" type="date" value-format="yyyy-MM-dd" format="yyyy-MM-dd" placeholder="选择日期" style="width: 180px" @change="v => getPreviewNo(v)">
            </el-date-picker>
          </el-form-item>
          <el-form-item label="单据编码:" required label-width="100px">
            <span style="display: inline-block; width: 180px" v-if="Mode == 0" class="detail-span">{{ data.DocNo }}</span>
            <el-input style="width: 180px" v-else v-model="data.DocNo" placeholder="请输入单据编码"></el-input>
          </el-form-item>
          <el-form-item label="业务类型:" label-width="100px">
            <span class="not-edit" style="width: 180px" v-if="Status === 2">{{ data.BusinessType }}</span>
            <!-- <business-select
              v-else
              v-model="data.BusinessTypeId"
              style="width: 190px"
            /> -->
            <el-select v-else v-model="data.BusinessTypeId" style="width: 180px">
              <el-option @click.native="BusinessChange(item)" v-for="item in businessTypeList" :key="item.BusinessTypeId" :label="item.BusinessType" :value="item.BusinessTypeId"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="仓库:" required label-width="100px">
            <span class="not-edit" v-if="Status === 2">{{ data.WarehouseName }}</span>
            <el-select v-else style="width: 180px" @change="changeDataSiteWarehouse" v-model="data.WarehouseId">
              <el-option v-for="item in warehouseList" :key="item.key" :label="item.label" :value="item.value"> </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="加工类型:" required label-width="100px">
            <span class="not-edit">{{ data.ProcessingType }}</span>
          </el-form-item>
          <!-- <el-form-item label="车间" required label-width="100px">
            <span class="not-edit" v-if="Status === 2">{{
              data.WorkShopName
            }}</span>
            <v-select
              v-else
              style="width:180px;"
              ref="typeSelect"
              v-model="data.WorkShopId"
            />
          </el-form-item> -->
          <el-form-item label="外协单位:" required label-width="100px">
            <span class="not-edit" v-if="Status === 2">{{ data.TradeUnitName }}</span>
            <el-select v-else style="width: 180px" filterable v-model="data.TradeUnitId" @change="changeTradeUnit">
              <el-option v-for="item in tradeUnitList" :key="item.TradeUnitId" :label="item.FullName" :value="item.TradeUnitId"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="经手人:" required label-width="100px">
            <span class="not-edit" v-if="Status === 2">{{ data.EmpName }}</span>
            <select-input v-else placeholder="请选择经办人" :label="data.EmpName" v-model="data.EmpId" @click="openEmp" style="width: 180px" />
          </el-form-item>
          <el-form-item label="制单人:" label-width="100px">
            <span class="span" style="width: 180px !important">{{ data.MakeEmpName }}</span>
          </el-form-item>
          <el-form-item label="入库类型:" label-width="100px">
            <span class="not-edit">按胶件入库</span>
          </el-form-item>
        </el-row>
        <el-row>
          <el-col :span="24">
            <el-form-item label="备注:" label-width="100px">
              <el-input type="textarea" v-model="data.Remark" :autosize="{ minRows: 2, maxRows: 4 }" maxlength="60" placeholder="请填写备注信息" :disabled="Status === 2" style="width: 600px" />
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <el-table key="table0" v-if="tableType === '注塑'" border class="table_bottom table-line tb-c-head" :row-class-name="tableRowClassName" :data="mouldData" stripe style="margin-top: 18px">
        <el-table-column label="加工单号" prop="SourceNo" align="left" min-width="110" />
        <el-table-column label="模号" prop="MouldNo" align="left" min-width="100" />
        <el-table-column label="模具名称" prop="MouldName" align="left" min-width="100" />
        <!-- <el-table-column :label="'需求重量'+'('+NeedUnit+')'" align="right" min-width="100">
          <template slot-scope="{ row }">
            <span>{{ (row.Quantity * row.PerNetWeight / NeedRate).toFixed(5) }}</span>
          </template>
        </el-table-column> -->
        <el-table-column label="数量" prop="Quantity" align="right" min-width="100">
          <template slot-scope="{ row }">
            <span class="not-edit">{{ $commonJs.toThousands(row.Quantity) }}</span>
          </template>
        </el-table-column>
        <el-table-column label="应入库数" prop="AnswerQuantity" align="right" min-width="100">
          <template slot-scope="{ row }">
            <span class="not-edit">{{ $commonJs.toThousands(row.AnswerQuantity) }}</span>
          </template>
        </el-table-column>
        <el-table-column label="累计入库数" prop="TotalInQuantity" align="right" min-width="100">
          <template slot-scope="{ row }">
            <span class="not-edit">{{ $commonJs.toThousands(row.TotalInQuantity) }}</span>
          </template>
        </el-table-column>
      </el-table>
      <el-table
        key="table1"
        ref="table1"
        border
        class="table_bottom table-line tb-c-head"
        :row-class-name="tableRowClassName"
        :data="tableData"
        @row-click="add_pro"
        stripe
        style="margin-top: 18px"
        v-if="showDetail"
      >
        <insert-row @on-insert="onInsert_pro" />
        <el-table-column min-width="160" align="left" label="备注" v-if="showField('备注')">
          <template slot-scope="{ row }">
            <span v-if="Status === 2">{{ row.Remark }}</span>
            <el-input v-else v-model="row.Remark" @change="editT(row)" placeholder="请输入备注" />
          </template>
        </el-table-column>
        <el-table-column label="加工单号" prop="SourceNo" align="left" min-width="120" key="table1_1" v-if="showField('加工单号')">
          <template slot-scope="{ row, $index }">
            <span class="not-edit" v-if="Status === 2">{{ row.SourceNo }}</span>
            <el-input type="text" @input="ProceNumInput(row, $index)" v-model="row.SourceNo" v-else @change="changeQuantity($event, row, $index)"></el-input>
          </template>
        </el-table-column>
        <el-table-column label="仓库" prop="WarehouseId" align="left" min-width="120" key="table1_2" v-if="showField('仓库')">
          <template slot-scope="{ row }">
            <span class="not-edit" v-if="Status === 2">{{ row.WarehouseName }}</span>
            <el-select v-else v-model="row.WarehouseId" @change="changeWarehouse($event, row)">
              <el-option v-for="item in warehouseList" :key="item.key" :label="item.label" :value="item.value"> </el-option>
            </el-select>
          </template>
        </el-table-column>
        <el-table-column label="存货名称" prop="ProductName" align="left" min-width="100" key="table1_3" v-if="showField('存货名称')">
          <template slot-scope="{ row, $index }">
            <span v-if="Status === 2">{{ row.ProductName }}</span>
            <el-select v-else v-model="row.ProductId" @change="onSelect_ProductName(row, $index)" @visible-change="onSelProduct(row)">
              <el-option v-for="item in row.Products" :key="item.ProductId" :label="item.ProductName" :value="item.ProductId"></el-option>
            </el-select>
          </template>
        </el-table-column>
        <el-table-column align="left" label="批号" min-width="180px" v-if="showField('批号')">
          <template slot-scope="{ row, $index }">
            <span v-if="!row.ProductName" style="color: #999">请先选择存货</span>
            <span v-else-if="tableType === '注塑' || Status === 2">{{ row.BatchNumber }}</span>
            <span v-else-if="!row.IsBatchNumber" class="text-gray">该存货未启用批号</span>
            <account-select
              v-else
              v-model="row.BatchNumber"
              :Head="Head"
              :source="batchList"
              :listTotal="batchListTotal"
              :pageType="true"
              :pageSize="batchPageParams.pageSize"
              :pageIndex="batchPageParams.pageIndex"
              @select="onSelBatch($event, row, $index)"
              @inputText="inputTextBatch($event, row)"
              @click.native="onOpenBatch($event, row, $index)"
              @currentPage="currentPage($event, row)"
            />
          </template>
        </el-table-column>
        <el-table-column label="存货编码" prop="ProductNo" align="left" min-width="160" key="table1_4" v-if="showField('存货编码')"> </el-table-column>
        <el-table-column align="left" label="批号起始日期" min-width="220px" v-if="showField('批号起始日期')">
          <template slot-scope="{ row }">
            <span v-if="tableType === '注塑' || Status === 2">{{ $commonJs.toDateString(row.BatchStartDate) }}</span>
            <el-date-picker
              v-else
              v-model="row.BatchStartDate"
              :disabled="!row.IsBatchNumber"
              type="date"
              value-format="yyyy-MM-dd"
              format="yyyy-MM-dd"
              @change="changeBatchStartDate(row)"
              placeholder="选择日期"
              style="width: 190px"
              :clearable="false"
            />
          </template>
        </el-table-column>
        <el-table-column label="存货条码" prop="Barcode" align="left" min-width="160" v-if="showField('存货条码')"> </el-table-column>
        <el-table-column label="规格型号" prop="ProductSpec" align="left" min-width="100" key="table1_5" v-if="showField('规格型号')"></el-table-column>
        <el-table-column label="装箱规格" prop="PackingSpeciId" align="left" min-width="100" v-if="showField('装箱规格')">
          <template slot-scope="{ row }">
            <el-select v-model="row.PackingSpeciId" @change="changeSpeci($event, row)">
              <el-option v-for="item in packingspeciList" :key="item.PackingSpeciId" :label="item.SpeciName" :value="item.PackingSpeciId" :disabled="item.Status == 0"></el-option>
            </el-select>
          </template>
        </el-table-column>
        <el-table-column label="每件数" prop="PackingNumber" align="left" min-width="100" v-if="showField('装箱数量')"></el-table-column>
        <el-table-column label="件数" prop="PackingQuantity" align="left" min-width="100" v-if="showField('件数')">
          <template slot-scope="{ row, $index }">
            <span class="not-edit" v-if="Status === 2">{{ $commonJs.toThousands(row.PackingQuantity) }}</span>
            <el-input type="text" v-else @change="changePackingQuantity($event, row, $index)" v-model="row.PackingQuantity"></el-input>
          </template>
        </el-table-column>
        <el-table-column label="属性" prop="PropertyId" align="left" min-width="100" key="table1_6" v-if="showField('属性')">
          <template slot-scope="{ row }">
            <el-select v-if="(row.UseProcess && Status !== 2) || (Status !== 2 && row.PropertyId)" v-model="row.PropertyId" @change="changeProperty($event, row)">
              <el-option v-for="item in propertyList" :key="item.PropertyId" :label="item.PropertyName" :value="item.PropertyId"></el-option>
            </el-select>
            <span class="not-edit" v-else>{{ row.UseProcess ? row.PropertyName : '' }}</span>
          </template>
        </el-table-column>
        <el-table-column label="颜色" prop="ColorId" align="left" min-width="100" key="table1_7" v-if="showField('颜色')">
          <template slot-scope="{ row }">
            <el-select v-if="(row.UseColor && Status !== 2) || (Status !== 2 && row.ColorId)" v-model="row.ColorId" @change="changeColor($event, row)">
              <el-option v-for="item in row.Colors" :key="item.ColorId" :label="item.ColorName" :value="item.ColorId" :disabled="item.Status == 0"></el-option>
            </el-select>
            <span class="not-edit" v-else>{{ row.UseColor ? row.ColorName : '' }}</span>
          </template>
        </el-table-column>

        <el-table-column align="left" label="计量单位" min-width="120px" v-if="showField('计量单位')">
          <template slot-scope="{ row, $index }">
            <el-select v-if="row.Units && row.Units.length > 0 && row.HasGrammage != true" v-model="row.UnitId" :disabled="Status === 2">
              <el-option v-for="item in row.Units" :key="item.UnitId" :value="item.UnitId" :label="item.UnitName" @click.native="compareSaUnit(item, row, $index)"></el-option>
            </el-select>
            <span v-else>{{ row.UnitName }}</span>
          </template>
          <!--  -->
        </el-table-column>
        <el-table-column label="数量" prop="Quantity" align="right" min-width="100" key="table1_9" v-if="showField('数量')">
          <template slot-scope="{ row, $index }">
            <span class="not-edit" v-if="Status === 2">{{ $commonJs.toThousands(row.Quantity) }}</span>
            <el-input type="text" v-else @change="changeQuantity($event, row, $index)" v-model="row.Quantity"></el-input>
          </template>
        </el-table-column>
        <el-table-column label="单价" prop="Price" align="right" min-width="100" key="table1_10" v-if="canPrice && showField('单价')">
          <template slot-scope="{ row }">
            <span class="not-edit" v-if="Status === 2">{{ row.Price }}</span>
            <el-input type="text" v-else @change="changePrice($event, row)" v-model="row.Price"></el-input>
          </template>
        </el-table-column>
        <el-table-column label="金额" prop="Amount" align="right" min-width="100" key="table1_11" v-if="canPrice && showField('金额')">
          <template slot-scope="{ row }">
            <span class="not-edit" v-if="Status === 2">{{ $commonJs.toThousands(row.Amount) }}</span>
            <el-input type="text" v-else @change="changeAmount($event, row)" v-model="row.Amount"></el-input>
          </template>
        </el-table-column>
        <el-table-column label="克重" prop="Grammage" align="right" min-width="100" v-if="showField('克重')">
          <template slot-scope="{ row, $index }">
            <span class="not-edit" v-if="Status === 2">{{ $commonJs.toThousands(row.Grammage) }}</span>
            <el-input type="text" v-else @change="changeGrammage($event, row, $index)" v-model="row.Grammage"></el-input>
          </template>
        </el-table-column>
        <el-table-column align="left" label="计量单位2" min-width="120px" v-if="showField('计量单位2')">
          <template slot-scope="{ row, $index }">
            <!-- <span>{{ row }}{{ $index }}</span> -->
            <el-select v-if="row.Units && row.Units.length > 0 && row.HasGrammage != true" v-model="row.UnitId2" :disabled="Status === 2">
              <el-option v-for="item in row.Units" :key="item.UnitId" :value="item.UnitId" :label="item.UnitName" @click.native="compareUnitId(item, row, $index)"></el-option>
            </el-select>
            <span v-else-if="row.UnitType == 0"></span>
            <span v-else>{{ row.UnitName2 }}</span>
          </template>
        </el-table-column>
        <el-table-column label="数量2" prop="Quantity2" align="right" min-width="100" v-if="showField('数量2')">
          <template slot-scope="{ row, $index }">
            <span class="not-edit" v-if="Status === 2">{{ $commonJs.toThousands(row.Quantity2) }}</span>
            <el-input v-else v-show="row.UnitId2 || (row.Units2 && row.Units2.length !== 0)" type="text" v-model="row.Quantity2" @change="changeQuantity2($event, row, $index)"></el-input>
          </template>
        </el-table-column>
        <el-table-column label="单价2" prop="Price2" align="right" min-width="100" v-if="canPrice && showField('单价2')">
          <template slot-scope="{ row }">
            <span class="not-edit" v-if="Status === 2">{{ row.Price2 }}</span>
            <el-input v-else v-show="row.UnitId2 || (row.Units2 && row.Units2.length !== 0)" type="text" v-model="row.Price2" @change="changePrice2($event, row)"></el-input>
          </template>
        </el-table-column>
        <el-table-column align="right" label="换算率" v-if="showField('换算率')">
          <template slot-scope="{ row, $index }">
            <span v-if="(Status === 2 || row.ChangeType === 0) && row.UnitType == 1">{{ row.Rate }}</span>
            <span v-else-if="row.UnitType == 0"></span>
            <span v-else-if="row.HasGrammage == true">{{ row.Rate }}</span>
            <el-input v-else type="text" v-model="row.Rate" @input="RateChange($event, row, $index)"></el-input>
          </template>
        </el-table-column>
        <el-table-column label="应入库数" prop="AnswerQuantity" align="right" min-width="100" v-if="showField('应入库数')">
          <template slot-scope="{ row }">
            <span class="not-edit">{{ $commonJs.toThousands(row.AnswerQuantity) }}</span>
          </template>
        </el-table-column>
        <el-table-column label="累计入库数" prop="TotalInQuantity" align="right" min-width="100" v-if="showField('累计入库数')">
          <template slot-scope="{ row }">
            <span class="not-edit">{{ $commonJs.toThousands(row.TotalInQuantity) }}</span>
          </template>
        </el-table-column>
        <el-table-column v-if="Status !== 2" label="操作" fixed="right" align="center" min-width="140" key="table1_12">
          <template slot-scope="{ row, $index }">
            <el-button type="text" @click="separate(row, $index)" v-if="row.ProductId > 0" :disabled="Status === 2">分箱</el-button>
            <el-button type="text" @click="del_pro1(row, $index)" :disabled="Status === 2">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <div class="mtx10">
        <div class="flex space-between">
          <div class="flex flex1">
            <div class="mrx18 center el-form-item__label">审核人</div>
            <div class="center el-form-item__label">{{ data.ReviewEmpName }}</div>
          </div>
          <div class="flex flex1">
            <div class="mrx18 center el-form-item__label">审核时间</div>
            <div class="center el-form-item__label">{{ data.ReviewTime }}</div>
          </div>
        </div>
      </div>
    </div>
    <edit-dialog ref="editDialog" @saved="saved" :Stage="Stage" :OrderType="OrderType"></edit-dialog>
    <emp-dialog ref="empDialog" in-dialog selectable @select="setEmp" />
    <field-dialog ref="fieldDialog" @close-saved="setTbField" />
    <separate-dialog ref="separateDialog" @saved="saveSeparate" :packingspeciList="packingspeciList"></separate-dialog>
  </div>
</template>
<script>
import editDialog from './editDialog'
import accountSelect from '@/components/business/stock/select'
import mouldSelect from '@/components/production/clothmanagement/cloth/select'

import vSelect from '@/components/business/stock/productionpicking/vSelect'
import empDialog from '@/components/personnel/result/record/listDialog'
import optionMixins from '@/mixins/option'
import fieldDialog from '@/components/common/fieldDialog'

export default {
  mixins: [optionMixins],
  name: 'editoutsourcedwarehousing1',
  components: {
    editDialog,
    accountSelect,
    vSelect,
    mouldSelect,
    empDialog,
    fieldDialog
  },
  data() {
    return {
      pdApi: require('@/api/ba/product').default,
      warehouseApi: require('@/api/ba/warehouse').default,
      businessTypeApi: require('@/api/ba/businessType').default,
      sourceTypeApi: require('@/api/ba/sourceType').default,
      mouldApi: require('@/api/ba/mould').default,
      colorApi: require('@/api/ba/color').default,
      code_api: require('@/api/sy/serialCode').default,
      commonApi: require('@/api/common/common').default,
      tradeUnitApi: require('@/api/ba/tradeUnit').default,
      api: require('@/api/stock/stInDoc').default,
      propertyApi: require('@/api/ba/property').default,
      docSetting_api: require('@/api/sy/docSetting').default,
      workDocApi: require('@/api/production/workDoc').default,
      packingspeciApi: require('@/api/ba/packingspeci').default,
      tradeUnitList: [],
      propertyList: [],
      Mode: 0,
      colorList: [],
      businessTypeList: [],
      warehouseList: [],
      initDAccount: [],
      initTotal: 0,
      DAccount: [],
      listTotal: 0,
      pageParams: {
        pageSize: 7, //分页大小
        pageIndex: 1
      },
      mouldHead: [
        { Value: 'MouldNo', Name: '模具编号', Width: '180' },
        { Value: 'MouldName', Name: '模具名称', Width: '150' }
      ],
      minitDAccount: [],
      minitTotal: 0,
      mDAccount: [],
      mlistTotal: 0,
      mpageParams: {
        pageSize: 7, //分页大小
        pageIndex: 1
      },
      viewType: 'create',
      Status: 0,
      data: {
        DocId: 0,
        InType: 2,
        DocDate: this.$commonJs.getToday(),
        DocNo: '',
        TradeUnitId: null,
        BusinessTypeId: '',
        WarehouseId: '',
        ItemValue: 0,
        MinusEntry: '',
        ItemText: 1,
        EmpName: '',
        EmpId: 0,
        MakeEmpName: '',
        MakeEmpId: 0,
        ReviewEmpName: '',
        ReviewEmpId: 0,
        ReviewTime: '',
        ProcessingType: '',
        BusinessTypeNo: '',
        BusinessType: '',
        Remark: '',
        TradeUnitName: '',
        AnswerQuantity: null,
        TotalInQuantity: null,
        BatchNumber: '',
        StorageMethod: 0 //0按胶件入库，1按模入库
      },
      tableType: '注塑',
      date: [],
      isSave: false,
      tableData: [],
      mouldData: [],
      delMouldData: [],
      delTableData: [],
      processList: [],
      isUseProcess: true,
      isUseColor: true,
      Stage: 0,
      OrderType: 0,
      NeedUnit: '斤',
      NeedRate: 500,
      detailFields: [],
      showDetail: false,
      Head: [
        { Value: 'BatchNumber', Name: '批号', Width: '180' },
        { Value: 'WarehouseName', Name: '仓库', Width: '100' },
        { Value: 'ColorName', Name: '颜色', Width: '80' },
        { Value: 'PropertyName', Name: '属性', Width: '80' },
        // { Value: "BatchStartDate", Name: "批次起始日期", Width: "100" },
        // { Value: "ExpireDate", Name: "有效期至", Width: "100" },
        { Value: 'BaseUnitName', Name: '主单位', Width: '80' },
        { Value: 'BaseQuantity', Name: '现存量', Width: '80' }
      ],
      batchListTotal: 0,
      batchPageParams: {
        pageSize: 7, //分页大小
        pageIndex: 1
      },
      batchList: [],
      packingspeciList: []
    }
  },
  created() {
    this.NeedUnit = localStorage.getItem('NeedUnit')
    this.NeedRate = localStorage.getItem('NeedRate')
    this.init()
  },
  computed: {
    canPrice() {
      return this.$permission.canPrice('/business/stock/outsourcedwarehousing')
    },
    canWrite() {
      return this.$permission.canWrite('/business/stock/outsourcedwarehousing')
    },
    canReview() {
      return this.$permission.canReview('/business/stock/outsourcedwarehousing')
    }
  },
  mounted() {
    this.viewType = this.$route.params.type

    if (this.$route.params.type === 'create') {
      this.getPreviewNo()
      const user = this.$store.state.user
      if (user) {
        this.data.EmpId = user.empId
        this.data.EmpName = user.name
      }
    } else if (this.$route.params.type === 'edit') {
      this.editInit(this.$route.params.data)
    }
    this.sourceTypeApi.info('生产工单产品').then(res => {
      this.SourceType = res.SourceTypeId
    })
  },
  methods: {
     separate(row, index) {
      let o = {
        ...row,
        index
      }
      this.$refs.separateDialog.openEdit(o)
    },
    saveSeparate(data) {
      console.log(data, 'saved')
      if (data) {
        var checkData = this.tableData[data.index]
        this.tableData.splice(data.index, 1)
        if (checkData.DocProductId > 0) {
          this.delTableData.push({ ...checkData, T: 2, WarehouseId: checkData.WarehouseId ?? 0 })
        }
        console.log(this.tableData, 'this.tableData')
        var arr = []
        data.list.forEach(item => {
          let o = {
            ...item,
            DocId:0,
            DocProductId: 0,
            T: 0,
          }
          console.log(o, 'separate')
          arr.push(o)
        })
        this.tableData.unshift(...arr)
        // data.list.forEach(item => {
        //   this.tableData.push(item)
        // })

        this.tableData.forEach((i, d) => {
          i.index = d      
        })      
      }
    },
    changePackingQuantity(val, row, index) {
      if (row.PackingNumber > 0) {
        if (val) {
          row.Quantity = parseInt(val * row.PackingNumber)
          if (row.HasGrammage == true) {
            row.Quantity2 = row.Quantity * row.Rate
          }
          if (this.data.ProcessingType === '注塑') {
            this.editMouldQua(row)
          }
        }
      }
    },
    changeSpeci(val, row) {
      let item = this.packingspeciList.filter(item => {
        return item.PackingSpeciId === val
      })[0]
      console.log(item, 'changeSpeci')
      if (item) {
        row.PackingNumber = item.PackingNumber
        row.RealPackingNumber = item.PackingNumber
        if (row.Quantity) {
          row.PackingQuantity = parseInt(row.Quantity / row.PackingNumber)
        }
      }
    },
    // 根据加工单号查询数据
    async ProceNumInput(row, index) {
      console.log('this.SourceType', this.SourceType)
      if (row.SourceNo.length >= 11) {
        //根据单号查询
        const res = await this.workDocApi.getDocList({ WorkDocNo: row.SourceNo })
        if (res.Data && res.Data.length > 0) {
          var doc = res.Data[0]
          console.log('getDocList', JSON.parse(JSON.stringify(doc)))
          if (doc.DpId) {
            row.WorkShopId = doc.DpId //单据的生产部门
          }
          this.workDocApi.info(doc.WorkDocId).then(res1 => {
            console.log('info', res1.Data)
            if (res1.Code == 0) {
              //PZ240123001
              var extraList = res1.Data.ProductModels
              if (extraList && extraList[0]) {
                let sourceNo = res1.Data.WorkDocNo
                let sourceId = res1.Data.WorkDocId
                let sourceDtsId = extraList[0].WorkDocProductId

                //模具对应的存货，用于下拉选择
                row.Products = extraList[0].BomRubbers.map(item => {
                  item.type = 1
                  item.InitQuantity = item.Quantity
                  if (this.docType === 1) {
                    item.Quantity = item.NeedQuanity - item.InQuantity
                  } else {
                    item.Quantity = item.NeedQuanity - item.DirectInQuantity
                  }

                  item.WorkDocNo = sourceNo
                  item.ProcessStage = 0
                  item.UnitId = item.SkUnitId
                  item.UnitName = item.SkUnitName
                  item._WorkDocProductId = sourceDtsId
                  item._WorkDocId = sourceId
                  item.SourceType = this.SourceType
                  return { ...item }
                })

                extraList.forEach(item => {
                  if (this.mouldData.findIndex(x => x.MouldId == item.MouldId) == -1) {
                    let { T, DocId = 0, DocMouldId = 0, Amount, MouldId, MouldName, PerNetWeight, MouldNo, Price, Quantity, WorkDocNo, TotalInQuantity, AnswerQuantity } = item

                    let o = {
                      T,
                      DocId,
                      DocMouldId,
                      Amount: Amount ?? 0,
                      MouldId,
                      MouldName,
                      MouldNo,
                      Price: Price ?? 0,
                      Quantity,
                      WorkDocNo,
                      PerNetWeight,
                      SourceId: item.WorkDocId,
                      SourceNo: item.WorkDocNo,
                      SourceDtsId: item.WorkDocProductId,
                      SourceType: this.SourceType,
                      childData: [],
                      TotalInQuantity,
                      AnswerQuantity
                    }
                    if (row.Products) o.childData = row.Products.map(x => ({ ...x, T: 0 }))
                    this.mouldData.unshift(o) //添加模具记录
                    console.log('this.mouldData', this.mouldData)
                  }
                })
              }
            }
          })
        }
      }
    },
    //更改克重
    changeGrammage(data, row, index, type = 0) {
      if (data == '-' || data == '.' || data == '') return
      console.log('row', row)
      this.editT(row)
      if (row.UnitType == 1) {
        if (row.HasGrammage == true) {
          row.Rate = Number((row.Grammage / row.Variable).toFixed(5))
          if (row.IsMain) {
            row.Quantity2 = this.getQuantity(row.Quantity * Number(row.Rate))
            console.log('row.IsMain1', row.IsMain, Number(row.Rate))
            if (type === 0) {
              row.Amount = this.setAmount(row.Price, row.Quantity)
            }
          } else {
            row.Quantity2 = this.getQuantity(row.Quantity / Number(row.Rate))
            console.log('row.IsMain2', row.IsMain, Number(row.Rate))
          }
        }
      }
      if (this.data.ProcessingType === '注塑' && type === 0) {
        this.editMouldQua(row)
      }
    },
    openSetField() {
      this.$refs.fieldDialog.open().then(that => {
        that.getData({ DocType: '委外入库单', Url: 'business/stock/outsourcedwarehousing/edit' })
      })
    },
    setTbField() {
      this.showDetail = false
      this.docSetting_api.list({ DocType: '委外入库单', IsShow: true }).then(res => {
        if (res.Code == 0) {
          this.detailFields = res.Data.map(x => x.FormKey)
          this.$nextTick(() => {
            this.showDetail = true
          })
        }
      })
    },
    showField(type) {
      return this.detailFields.indexOf(type) != -1
    },
    onInsert(e) {
      let { type, index } = e
      this.interpolate(null, index, type)
    },
    changeDataSiteWarehouse(val) {
      // let item = this.warehouseList.filter((item) => {
      //   return item.value === val;
      // })[0];
      // for (let i = 0; i < this.tableData.length; i++) {
      //   if (this.tableData[i].T !== 0) {
      //     this.tableData[i].T = 1;
      //   }
      //   (this.tableData[i].WarehouseId = item.value),
      //     (this.tableData[i].WarehouseName = item.label);
      // }
    },
    interpolate(row, index, type = '') {
      let o = {
        T: 0,
        DocId: 0,
        DocMouldId: 0,
        WorkDocNo: '',
        MouldId: 0,
        MouldNo: '',
        MouldName: '',
        PerNetWeight: '',
        Quantity: 0,
        Price: 0,
        Amount: 0,
        SourceId: 0,
        SourceNo: '',
        SourceDtsId: 0,
        SourceType: 0
      }
      if (type == 'down') {
        index = index + 1
      }
      this.mouldData.splice(index, 0, o)
      let copy = JSON.parse(JSON.stringify(this.mouldData))
      this.mouldData = []
      this.$nextTick(() => {
        this.mouldData = copy
      })
      console.log('this.tableData', this.mouldData)
    },
    onInsert_pro(e) {
      let { type, index } = e

      this.interpolate_pro(null, index, type)
    },
    interpolate_pro(row, index, type = '') {
      let o = {
        T: 0,
        WorkDocNo: '',
        WarehouseId: '',
        ProductName: '',
        ProductNo: '',
        ProductSpec: '',
        PropertyId: null,
        PropertyName: '',
        Colors: [],
        ColorId: null,
        ColorName: '',
        UnitId: null,
        UnitName: '',
        Units: [],
        Quantity: '',
        Price: '',
        Amount: '',
        SourceId: 0,
        SourceNo: '',
        SourceDtsId: 0,
        SourceType: 0,
        ProductionType: 1,
        ProductionDpId: this.data.TradeUnitId
      }
      if (type == 'down') {
        index = index + 1
      }
      this.tableData.splice(index, 0, o)
      let copy = JSON.parse(JSON.stringify(this.tableData))
      this.tableData = []
      this.$nextTick(() => {
        this.tableData = copy
      })
      console.log('this.tableData', this.tableData)
    },
    setEmp(data) {
      console.log(data)
      this.data.EmpId = data.EmpId
      this.data.EmpName = data.EmpName
    },
    openEmp() {
      this.$refs.empDialog.open().then(that => {
        that.getData()
      })
    },
    getPreviewNo(dateTime = '') {
      this.code_api.previewNo('委外入库单', dateTime).then(res => {
        if (res.Code == 0) {
          this.Mode = res.Data.Mode
          this.data.DocNo = res.Data.PreviewNo
        } else {
          this.$message.warning('获取委外入库单编号失败')
        }
      })
    },
    editInit(data) {
      console.log('data', data)
      this.viewType = 'edit'
      this.isSave = true
      let {
        BusinessType,
        BusinessTypeId,
        BusinessTypeNo,
        DocDate,
        DocId,
        DocNo,
        EmpId,
        EmpName,
        InType,
        MakeEmpId,
        MakeEmpName,
        Moulds,
        ProcessingType,
        Products,
        Remark,
        ReviewEmpId,
        ReviewEmpName,
        ReviewTime,
        Status,
        WarehouseId,
        WarehouseName,
        TradeUnitId,
        TradeUnitName,
        StorageMethod
      } = data

      WarehouseId = WarehouseId !== 0 ? WarehouseId : null

      this.data = {
        BusinessType,
        BusinessTypeId,
        BusinessTypeNo,
        DocDate,
        DocId,
        DocNo,
        EmpId,
        EmpName,
        InType,
        MakeEmpId,
        MakeEmpName,
        ProcessingType,
        Remark,
        ReviewEmpId,
        ReviewEmpName,
        ReviewTime,
        WarehouseId,
        WarehouseName,
        TradeUnitId,
        TradeUnitName,
        StorageMethod,
        ItemText: 1
      }

      this.tableType = ProcessingType

      this.Status = Status

      Moulds.forEach(item => {
        item.T = null
      })

      Products.forEach((item, i) => {
        item.T = null
        item.IsBatchNumber = item.BatchNumber ? true : false
        item.PropertyId = item.PropertyId !== 0 ? item.PropertyId : null
        item.ColorId = item.ColorId !== 0 ? item.ColorId : null
        item.WarehouseId = item.WarehouseId !== 0 ? item.WarehouseId : null
        item.UnitId = item.UnitId !== 0 ? item.UnitId : item.SkUnitId
        item.UnitName = item.UnitName !== '' ? item.UnitName : item.SkUnitName

        item.isSource = item.SourceNo === '' || item.SourceNo == null ? false : true
         if (item.Barcode === '' || item.Barcode == null) {
          var colorNo = '0'
          var propertyNo = '0'
          if (item.ColorId > 0) {
            var color = item.Colors.find(x => x.ColorId == item.ColorId)
            if (color) {
              colorNo = color.ColorNo
            }
          }
          if (item.PropertyId > 0) {
            var property = this.propertyList.find(x => x.PropertyId == item.PropertyId)
            if (property) {
              propertyNo = property.PropertyNo
            }
          }
          item.Barcode = item.ProductNo + '*' + colorNo + '*' + propertyNo
        }

        if (item.Units.length === 0) {
          item.UnitType = 0
          item.UnitId = item.UnitId ?? item.SkUnitId
          item.UnitName = item.UnitName ?? item.SkUnitName
          item.UnitId2 = 0
          // row.SaUnitName = e.SaUnitName;
          item.UnitName2 = ''
          item.Rate = 0
          item.Quantity2 = 0
        } else {
          item.UnitType = 1
          let index = this.getUnitIndex(3, item.Units, item.UnitId)
          let data = this.getUnitValue(item.Units, index)
          let assistIndex = 0
          let assistData = {}
          item.IsMain = data.IsMain
          // row.ChangeType1 = data.ChangeType;
          item.Units.forEach(v => {
            if (v.ChangeType == 1) item.ChangeType = v.ChangeType
          })

          if (item.UnitId2 == null || item.UnitId2 == 0) {
            if (data.IsMain) {
              assistIndex = this.getUnitIndex(2, item.Units)
              assistData = this.getUnitValue(item.Units, assistIndex)
              item.Rate = assistData.Rate.toFixed(5)
            } else {
              assistIndex = this.getUnitIndex(1, item.Units)
              assistData = this.getUnitValue(item.Units, assistIndex)
              item.Rate = data.Rate.toFixed(5)
            }
            item.UnitId2 = assistData.UnitId
            item.UnitName2 = assistData.UnitName
          }

          if (item.Quantity2 == null) {
            this.changeQuantity(item.Quantity, item, i)
          }
        }
      })

      // if (Moulds) {
      //   if (Moulds.length > 0) {
      //     Moulds.forEach((item) => {
      //       item.SourceNo = Products[0].SourceNo;
      //     });
      //   }
      // }

      this.mouldData = Moulds
      this.tableData = Products
      console.log('this.mouldData', this.mouldData)

      if (this.mouldData.length > 0) {
        this.tableData.forEach(item => {
          let v = this.mouldData.filter(v => {
            return item.MouldId === v.MouldId
          })[0]
          console.log('item', item)
          console.log('v', v)

          item.mouldRate = item.Quantity / v.Quantity
          item.Products = [
            {
              ProductId: item.ProductId,
              ProductName: item.ProductName
            }
          ]
        })
      }

      console.log('this.tableData', this.tableData)
    },
    init() {
      let SET_PurchaseReceipt = null
      if (localStorage.getItem('SET_PurchaseReceipt') === 'true') {
        SET_PurchaseReceipt = true
      } else {
        SET_PurchaseReceipt = false
      }

      this.newLine_pro() //打开时增加一条胶件明细

      this.commonApi.getDictionaryList({ Code: 'ProductStage' }).then(res => {
        if (res.Code === 0) {
          this.processList = res.Data
          // this.processList = res.Data.filter((v) => {
          //   return v.Code === "ProductStage";
          // });
          for (let i = 0; i < this.processList.length; i++) {
            if (this.data.ProcessingType) {
              if (this.processList[i].ItemText == this.data.ProcessingType) {
                this.data.DictionaryId = this.processList[i].DictionaryId
                this.data.ItemValue = this.processList[i].ItemValue
                return
              }
            } else {
              if (this.processList[i].ItemText == '注塑') {
                this.data.ProcessingType = this.processList[i].ItemText
                this.data.DictionaryId = this.processList[i].DictionaryId
                this.data.ItemValue = this.processList[i].ItemValue
              }
            }
          }
        }
      })

      this.packingspeciApi.list({ Status: 1 }).then(res => {
        if (res.Code === 0) {
          this.packingspeciList = res.Data
        }
      })
      this.propertyApi
        .list({
          Status: 1
        })
        .then(res => {
          if (res.Code === 0) {
            this.propertyList = res.Data
          }
        })

      this.pdApi
        .list({
          Status: 1,
          PageIndex: this.pageParams.pageIndex,
          pageSize: this.pageParams.pageSize
        })
        .then(res => {
          this.DAccount = res.Data
          this.initDAccount = res.Data
          this.listTotal = res.Count
          this.initTotal = res.Count
        })

      this.mouldApi
        .list({
          Statuses: [1, 2],
          PageIndex: this.mpageParams.pageIndex,
          pageSize: this.mpageParams.pageSize
        })
        .then(res => {
          this.mDAccount = res.Data
          this.minitDAccount = res.Data
          this.mlistTotal = res.Count
          this.minitTotal = res.Count
        })

      let WarehouseTypes = []
      if (SET_PurchaseReceipt) {
        WarehouseTypes = [1, 3]
      } else {
        WarehouseTypes = [1]
      }

      this.warehouseApi.list({ Status: 1, WarehouseTypes: WarehouseTypes }).then(res => {
        if (res.Code === 0) {
          if (this.viewType === 'create') {
            this.data.WarehouseId = res.Data[0].WarehouseId
            this.data.WarehouseName = res.Data[0].WarehouseName
          }
          this.warehouseList = res.Data.map(item => {
            return {
              key: item.WarehouseId,
              label: item.WarehouseName,
              value: item.WarehouseId
            }
          })
        }
      })

      this.sourceTypeApi.list({}).then(res => {
        if (res.Code == 0) {
          this.SourceTypeIdArr = res.Data
          let params = '委外入库单'
          let index = this.SourceTypeIdArr.findIndex(item => item.SourceType == params)
          let SourceTypeId = this.SourceTypeIdArr[index].SourceTypeId
          this.data.InType = SourceTypeId
          this.businessTypeApi.getSourceTypeToBusinessType(SourceTypeId).then(res => {
            if (res.Code == 0) {
              this.businessTypeList = res.Data
              if (this.viewType !== 'edit') {
                this.data.BusinessTypeId = this.businessTypeList[0].BusinessTypeId
                this.data.BusinessType = this.businessTypeList[0].BusinessType
                this.data.MinusEntry = this.businessTypeList[0].MinusEntry
                this.changeNumber(this.data.MinusEntry)
              } else {
                console.log('this.data.BusinessTypeId', this.data.BusinessTypeId)
                let item = this.businessTypeList.filter(item => {
                  return item.BusinessTypeId === this.data.BusinessTypeId
                })[0]

                this.data.MinusEntry = item.MinusEntry

                this.changeNumber(this.data.MinusEntry)
              }
            }
          })
        }
      })

      this.tradeUnitApi.list({ TradeUnitType: 3, Status: 1 }).then(res => {
        if (res.Code === 0) {
          console.log('res.Data', res.Data)
          this.tradeUnitList = res.Data
        }
      })

      this.callOptionApi()
      this.setTbField()
    },
    async goJump(index) {
      let params = {}
      let ids = []
      let res = null
      switch (index) {
        case 1:
          ids = this.tableData
            .filter(item => {
              return item.SourceType === 42
            })
            .map(item => {
              return item.SourceDocId
            })

          if (ids.length === 0) {
            this.$message.error('单据未引用工单，无法进行联查')
          } else {
            params.Ids = ids
            params.ProductionType = 1
            this.$router.push({ name: 'workorder', params: params })
          }
          break
      }
    },
    BusinessChange(val) {
      this.data.BusinessTypeId = val.BusinessTypeId
      this.data.MinusEntry = val.MinusEntry
      this.data.BusinessType = val.BusinessType
      this.changeNumber(this.data.MinusEntry)
    },
    changeNumber(status) {
      if (status) {
        this.tableData.forEach((item, index) => {
          item.Quantity = item.Quantity > 0 ? 0 - item.Quantity : item.Quantity
          item.Quantity2 = item.Quantity2 > 0 ? 0 - item.Quantity2 : item.Quantity2
          item.Amount = item.Amount == null ? item.Amount : this.setAmount(item.Quantity, item.Price)

          if (item.T !== 0) {
            item.T = 1
          }
        })

        this.mouldData.forEach((item, index) => {
          item.Quantity = item.Quantity > 0 ? 0 - item.Quantity : item.Quantity
          item.Amount = item.Amount == null ? item.Amount : this.setAmount(item.Quantity, item.Price)
          if (item.T !== 0) {
            item.T = 1
          }
        })
      } else {
        this.tableData.forEach((item, index) => {
          item.Quantity = item.Quantity == null ? item.Quantity : Math.abs(item.Quantity)
          item.Quantity2 = item.Quantity2 == null ? item.Quantity2 : Math.abs(item.Quantity2)
          item.Amount = item.Amount == null ? item.Amount : this.setAmount(item.Quantity, item.Price)

          if (item.T !== 0) {
            item.T = 1
          }
        })

        this.mouldData.forEach((item, index) => {
          item.Quantity = item.Quantity == null ? item.Quantity : Math.abs(item.Quantity)
          item.Amount = item.Amount == null ? item.Amount : this.setAmount(item.Quantity, item.Price)
          if (item.T !== 0) {
            item.T = 1
          }
        })
      }
    },
    /** 点击下拉存货 */
    async onSelProduct(row) {
      console.log('this.workDocApi', this.workDocApi)
      console.log('row', row)
      let _Products = []
      await this.workDocApi.info(row.SourceId).then(res1 => {
        if (res1.Code == 0) {
          //PZ240123001
          var extraList = res1.Data.ProductModels
          if (extraList && extraList[0]) {
            let sourceNo = res1.Data.WorkDocNo
            let sourceId = res1.Data.WorkDocId
            let sourceDtsId = extraList[0].WorkDocProductId

            //模具对应的存货，用于下拉选择
            _Products = extraList[0].BomRubbers.map(item1 => {
              item1.type = 1
              item1.InitQuantity = item1.Quantity
              if (this.docType === 1) {
                item1.Quantity = item1.NeedQuanity - item1.InQuantity
              } else {
                item1.Quantity = item1.NeedQuanity - item1.DirectInQuantity
              }

              item1.WorkDocNo = sourceNo
              item1.ProcessStage = 0
              item1.UnitId = item1.PdUnitId
              item1.UnitName = item1.PdUnitName
              item1._WorkDocProductId = sourceDtsId
              item1._WorkDocId = sourceId
              return { ...item1 }
            })
            console.log('_Products1111', _Products)
            this.tableData = this.tableData.map(item => {
              return {
                ...item,
                Products: _Products
              }
            })
          }
        }
      })
      // await this.workDocApi.info(row.SourceId).then(res => {
      //   var products = res.Data.ProductModels[0].Rubbers.map(item => {
      //     return {
      //       ProductId:item.ProductId,
      //       ProductName:item.ProductName
      //     }
      //   })
      //   this.tableData = this.tableData.map(item => {
      //     return {
      //       ...item,
      //       Products: products
      //     }
      //   })
      // })
      this.ProceNumInput(row)
      console.log('this.tableData:', this.tableData)
    },
    //选中存货
    onSelect_ProductName(row, index) {
      this.editT(row)
      var e = row.Products.find(x => x.ProductId == row.ProductId)
      row.SourceId = e.type === 1 ? e._WorkDocId : e.WorkDocId

      row.IsBatchNumber = e.IsBatchNumber ?? false
      row.BatchNumber = null
      row.BatchStartDate = row.IsBatchNumber ? row.BatchStartDate : null

      // row.SourceNo = "";
      row.SourceDtsId = e.type === 1 ? e._WorkDocProductId : e.WorkDocProductId
      row.SourceType = this.SourceType

      row.Colors = []
      row.Units = []

      row.Barcode = e.ProductNo + '*0*0'
      row.ColorId = e.ColorId
      row.PropertyId = e.PropertyId

      row.UnitName = e.UnitName
      row.ColorName = e.ColorName

      row.ProductName = e.ProductName
      row.ProductNo = e.ProductNo
      row.ProductId = e.ProductId
      row.ProductSpec = e.ProductSpec
      row.Colors = e.Colors
      row.Units = e.Units

      row.UseColor = e.UseColor
      row.UseProcess = e.UseProcess
      row.TotalInQuantity = e.InQuantity
      row.AnswerQuantity = e.AnswerQuantity
      // row.SourceType = 0;
      // row.Quantity = 0;
      // row.Price = 0;
      // row.Amount = 0;
      row.WarehouseId = this.data.WarehouseId
      row.WarehouseName = this.data.WarehouseName

      row.ChangeType = e.ChangeType
      row.UnitType = e.UnitType
      row.UnitId2 = e.UnitId2
      row.UnitId = e.UnitId !== 0 ? e.UnitId : e.SkUnitId

      row.HasGrammage = e.HasGrammage
      row.Grammage = e.Grammage
      row.Variable = e.Variable

      if (e.Units.length === 0) {
        row.UnitId = e.UnitId !== 0 ? e.UnitId : e.SkUnitId
        row.UnitName = e.UnitName !== '' ? e.UnitName : e.SkUnitName
        row.UnitId2 = 0
        // row.SaUnitName = e.SaUnitName;
        row.UnitName2 = ''
        row.Rate = 0
        row.Quantity2 = 0
      } else {
        row.UnitType = 1
        e.Units.forEach(item => {
          if (item.ChangeType == 1) row.ChangeType = item.ChangeType
        })
        if (row.UnitId) {
          let index = this.getUnitIndex(3, e.Units, row.UnitId)
          let data = this.getUnitValue(e.Units, index)
          let assistIndex = 0
          let assistData = {}
          row.IsMain = data.IsMain
          // row.ChangeType1 = data.ChangeType;

          if (data.IsMain) {
            assistIndex = this.getUnitIndex(2, e.Units)
            assistData = this.getUnitValue(e.Units, assistIndex)
            row.Rate = assistData.Rate.toFixed(5)
          } else {
            assistIndex = this.getUnitIndex(1, e.Units)
            assistData = this.getUnitValue(e.Units, assistIndex)
            row.Rate = data.Rate.toFixed(5)
          }
          row.UnitId2 = assistData.UnitId
          row.UnitName2 = assistData.UnitName
        } else {
          let untiLength = e.Units.length
          let mainData = []
          let noMainData = []
          for (let i = 0; i < untiLength; ++i) {
            if (e.Units[i].IsMain) {
              mainData.push(e.Units[i])
            } else {
              noMainData.push(e.Units[i])
            }
          }
          row.UnitId = mainData[0].UnitId
          row.UnitName = mainData[0].UnitName
          row.UnitId2 = noMainData[0].UnitId
          row.UnitName2 = noMainData[0].UnitName
          row.Rate = noMainData[0].Rate.toFixed(5)
          row.IsMain = true
        }
      }
      this.changeQuantity(this.tableData[index].Quantity, row, index, 1)
      console.log('row', JSON.parse(JSON.stringify(row)))
    },
    changeBusinessType(val) {
      let item = this.businessTypeList.filter(item => {
        return val === item.BusinessTypeId
      })[0]

      this.data.BusinessTypeId = item.BusinessTypeId
      this.data.BusinessTypeNo = item.BusinessTypeNo
      this.data.BusinessType = item.BusinessType
    },
    changeTradeUnit(val) {
      let item = this.tradeUnitList.filter(item => {
        return val === item.TradeUnitId
      })[0]

      this.data.TradeUnitId = item.TradeUnitId
      this.data.TradeUnitName = item.ShortName
    },
    setProduct(id, row) {
      let tableData_mouldId = this.tableData.map(item => {
        return item.MouldId
      })

      if (tableData_mouldId.indexOf(id) !== -1) {
        this.$message({ type: 'warning', message: '请不要选择重复的模具' })
        return
      }

      this.mouldApi.info(id).then(res => {
        if (res.Code === 0) {
          let tableData = []
          let Rubbers = res.Data.Rubbers
          row.Rubbers = Rubbers

          Rubbers.forEach(item => {
            let o = {
              T: 0,
              WorkDocNo: '',
              DocId: 0,
              DocProductId: 0,
              MouldId: item.MouldId,
              ProductId: item.ProductId,
              ProductName: item.ProductName,
              ProductNo: item.ProductNo,
              ProductSpec: '',
              Property: '',
              Colors: item.Colors || [],
              ColorId: null,
              ColorName: '',
              UnitId: item.SkUnitId,
              UnitName: item.SkUnitName,
              WarehouseId: item.DefaultWarehouse,
              WarehouseName: '',
              Units: item.Units || [],
              Quantity: item.Quantity,
              Price: null,
              Amount: null,
              mouldRate: item.Quantity,
              ProductSpec: item.ProductSpec,
              PropertyId: null,
              PropertyName: '',
              SourceId: 0,
              SourceNo: '',
              SourceDtsId: 0,
              SourceType: 0,
              ProductionType: 1,
              ProductionDpId: this.data.TradeUnitId,

              UseColor: item.UseColor,
              UseProcess: item.UseProcess,
              AnswerQuantity: null,
              TotalInQuantity: null,

              UnitId2: 0,
              UnitName2: '',
              Quantity2: null,
              Price2: null,
              Rate: null,
              Remark: ''
            }

            tableData.push(o)
          })
          if (!this.tableData.length && this.data.WarehouseId != tableData[0].WarehouseId) {
            this.data.WarehouseId = tableData[0].WarehouseId
            this.data.WarehouseName = ''
          }
          this.tableData.push(...tableData)

          let mouldIds = this.mouldData
            .map(item => {
              return item.MouldId
            })
            .filter(item => {
              return item !== 0
            })

          let pds = this.tableData
            .filter(item => {
              return mouldIds.indexOf(item.MouldId) === -1
            })
            .map(item => {
              return item.ProductId
            })

          this.del_pro(pds)

          this.tableData.forEach((item, index) => {
            item.isSource = item.SourceNo === '' || item.SourceNo == null ? false : true
            item.ChangeType = 0
            item.UnitType = 0

            if (item.Units.length === 0) {
              item.UnitId2 = 0
              // row.SaUnitName = e.SaUnitName;
              item.UnitName2 = ''
              item.Rate = 0
              // item.Quantity2=0;
            } else {
              item.UnitType = 1
              item.Units.forEach(v => {
                if (v.ChangeType == 1) item.ChangeType = v.ChangeType
              })
              if (item.UnitId) {
                let index = this.getUnitIndex(3, item.Units, item.UnitId)
                let data = this.getUnitValue(item.Units, index)
                let assistIndex = 0
                let assistData = {}
                item.IsMain = data.IsMain
                // row.ChangeType1 = data.ChangeType;

                if (data.IsMain) {
                  assistIndex = this.getUnitIndex(2, item.Units)
                  assistData = this.getUnitValue(item.Units, assistIndex)
                  item.Rate = assistData.Rate.toFixed(5)
                } else {
                  assistIndex = this.getUnitIndex(1, item.Units)
                  assistData = this.getUnitValue(item.Units, assistIndex)
                  item.Rate = data.Rate.toFixed(5)
                }
                item.UnitId2 = assistData.UnitId
                item.UnitName2 = assistData.UnitName
                this.changeQuantity(item.Quantity, item, index)
              } else {
                let untiLength = item.Units.length
                let mainData = []
                let noMainData = []
                for (let i = 0; i < untiLength; ++i) {
                  if (item.Units[i].IsMain) {
                    mainData.push(item.Units[i])
                  } else {
                    noMainData.push(item.Units[i])
                  }
                }
                item.UnitId = mainData[0].UnitId
                item.UnitName = mainData[0].UnitName
                item.UnitId2 = noMainData[0].UnitId
                item.UnitName2 = noMainData[0].UnitName
                item.Rate = noMainData[0].Rate.toFixed(5)
                item.IsMain = true
                this.changeQuantity(item.Quantity, item, index)
              }

              // row.ChangeType2 = assistData.ChangeType;
            }
          })
        }
      })
    },
    getUnitValue(arr, findIndex) {
      let data = {}
      data.UnitId = arr[findIndex].UnitId
      data.UnitName = arr[findIndex].UnitName
      data.IsMain = arr[findIndex].IsMain
      data.ChangeType = arr[findIndex].ChangeType
      data.Rate = arr[findIndex].Rate
      return data
    },
    compareSaUnit(data, row, index) {
      if (row.T === 3) row.T = 1

      this.editT(row)

      let lastIsMain = row.IsMain
      this.tableData[index].IsMain = data.IsMain
      let findIndex = 0
      if (row.UnitId == row.UnitId2) {
        let num = 0
        num = row.Quantity
        row.Quantity = row.Quantity2
        row.Quantity2 = num

        if (data.IsMain) {
          //当前选择的主单位
          findIndex = this.getUnitIndex(2, this.tableData[index].Units)
          this.changeRightUnitId(index, findIndex)
          // row.ChangeType1 = data.ChangeType;
        } else {
          findIndex = this.getUnitIndex(1, this.tableData[index].Units)
          this.changeRightUnitId(index, findIndex)
          // row.ChangeType1 = data.ChangeType;
        }
      } else {
        if (data.IsMain) {
          findIndex = this.getUnitIndex(2, this.tableData[index].Units)
          this.changeRightUnitId(index, findIndex)
          // row.ChangeType1 = data.ChangeType;
        } else {
          findIndex = this.getUnitIndex(1, this.tableData[index].Units)
          this.changeRightUnitId(index, findIndex, data.Rate)
          // row.ChangeType1 = data.ChangeType;
          if (lastIsMain) {
            row.Quantity2 = row.Quantity
          }
          // row.Quantity = (row.Quantity2 / Number(data.Rate)).toFixed(5);
          row.Quantity = this.getQuantity(row.Quantity2 / Number(data.Rate))
        }
      }
      this.changeQuantity(this.tableData[index].Quantity, row, index, 1)

      let val = this.setNumber(Math.abs(row.Amount / row.Quantity))
      row.Price = this.getPrice(val)

      val = this.setNumber(Math.abs(row.Amount / row.Quantity2))
      row.Price2 = this.getPrice(val)
    },
    //传入数组 索引 返回对应的 id 和name index是table索引  findIndex 是当前主辅单位索引
    changeRightUnitId(index, findIndex, Rate = 0) {
      this.tableData[index].UnitId2 = this.tableData[index].Units[findIndex].UnitId
      this.tableData[index].UnitName2 = this.tableData[index].Units[findIndex].UnitName
      // this.tableData[index].ChangeType2=this.tableData[index].Units[findIndex].ChangeType

      if (Rate > 0) {
        this.tableData[index].Rate = Rate
      }
    },
    //获取计量单位主辅单位的索引
    getUnitIndex(type, arr, id = '') {
      let index = 0
      if (type == 1) {
        //获取主单位索引
        index = arr.findIndex(el => el.IsMain == true)
      } else if (type == 2) {
        //获取数组第一个不是主单位的索引
        index = arr.findIndex(el => el.IsMain == false)
      } else {
        //获取当前传入id的索引
        index = arr.findIndex(el => id == el.UnitId)
      }
      return index
    },
    // changeQuantity(data, row, index, type = 0, init = false) {
    //   if(data=='-' || data== '.' || data==''){
    //       return
    //   }
    //   console.log('init===', init)
    //   if(!init){
    //     this.editT(row)
    //   }

    //   if(this.data.MinusEntry){
    //         row.Quantity > 0 ? row.Quantity=0-row.Quantity  :  row.Quantity
    //         row.Quantity2 > 0 ? row.Quantity2=0-row.Quantity2 : row.Quantity2;
    //         data = data > 0 ? 0 - data : data;
    //   }else{
    //          row.Quantity=Math.abs(row.Quantity)
    //         row.Quantity2=Math.abs(row.Quantity2)
    //         data = Math.abs(data)
    //   }
    //   if (row.T == 3) this.tableData[index].T = 1;
    //   if(row.Units.length>0){
    //     if(row.IsMain){
    //       // row.Quantity2= (row.Quantity / Number(row.Rate)).toFixed(5);
    //       row.Quantity2 = this.getQuantity((row.Quantity / Number(row.Rate)))
    //       if(type === 0){
    //         row.Amount = this.setAmount(row.Price, row.Quantity);
    //       }

    //     }else{

    //       row.Quantity2 = this.getQuantity((data * Number(row.Rate)))
    //       if(type === 0){
    //         row.Amount = this.setAmount(row.Price, row.Quantity);
    //       }

    //       // if(row.ChangeType == 1 && row.Quantity2 != 0){
    //       //   row.Rate= Math.abs(Number(row.Quantity2/data)).toFixed(5);
    //       //   if(type === 0){
    //       //     let val = this.setNumber(Math.abs(row.Amount / data))
    //       //     row.Price = this.getPrice(val);
    //       //   }
    //       // }else if(row.Quantity2 == 0){
    //       //   // row.Quantity2 = (data * Number(row.Rate)).toFixed(5);
    //       //   row.Quantity2 = this.getQuantity((data * Number(row.Rate)))
    //       //   if(type === 0){
    //       //     row.Amount = this.setAmount(row.Price, row.Quantity);
    //       //   }
    //       // }else if(row.ChangeType == 0 ){
    //       //   // row.Quantity2 = (data * Number(row.Rate)).toFixed(5);
    //       //   row.Quantity2 = this.getQuantity((data * Number(row.Rate)))
    //       //   if(type === 0){
    //       //     row.Amount = this.setAmount(row.Price, row.Quantity);
    //       //   }
    //       // }

    //     }
    //   }else{
    //     row.Quantity2=row.Quantity
    //     row.Amount = this.setAmount(row.Price, row.Quantity);
    //   }

    // },
    editMouldQua(row) {
      console.log('row', row)

      // 先确定最小比例
      let list = this.tableData.filter(item => {
        return item.MouldId === row.MouldId
      })

      const groupedSum = new Map()
      console.log('list', list)
      list.forEach(item => {
        if (!groupedSum.has(item.ProductId)) {
          groupedSum.set(item.ProductId, 0) // 初始化分组总和为0
        }
        if (item.UnitName == '个') {
          groupedSum.set(item.ProductId, groupedSum.get(item.ProductId) + Math.ceil(item.Quantity * item.mouldRate)) // 累加值
        } else {
          groupedSum.set(item.ProductId, groupedSum.get(item.ProductId) + Math.ceil(item.Quantity2 * item.mouldRate)) // 累加值
        }
      })
      const resultArray = Array.from(groupedSum, ([key, value]) => ({ id: key, qua: value }))
      resultArray.sort((a, b) => a.qua - b.qua)
      console.log(resultArray, 'resultArray')

      // //防止单位切换用斤去算那就完蛋  list[0].UnitName == "个"
      // let minQua = Math.ceil((list[0].UnitName == "个" ? list[0].Quantity : list[0].Quantity2) * list[0].mouldRate)
      // let length = list.length;
      // for (let i = 1; i < length; ++i) {

      //   let qua = Math.ceil((list[i].UnitName == "个" ? list[i].Quantity : list[i].Quantity2) * list[i].mouldRate)
      //   if (minQua > qua) {
      //     minQua = qua
      //   }
      // }

      // // 获取id的模具，修改模具数量，并且修改金额
      // console.log("minQua", minQua, typeof minQua);

      this.mouldData.forEach(item => {
        if (item.MouldId === row.MouldId) {
          item.Quantity = resultArray[0].qua
          item.Amount = this.setAmount(item.Quantity, item.Price)
        }
      })
    },
    changeQuantity(data, row, index, type = 0, init = false) {
      if (data == '-' || data == '.' || data == '') {
        return
      }
      this.editT(row)

      if (this.data.MinusEntry) {
        row.Quantity > 0 ? (row.Quantity = 0 - row.Quantity) : row.Quantity
        row.Quantity2 > 0 ? (row.Quantity2 = 0 - row.Quantity2) : row.Quantity2
      } else {
        row.Quantity = Math.abs(row.Quantity)
        row.Quantity2 = Math.abs(row.Quantity2)
      }
      if (row.T == 3) this.tableData[index].T = 1
      if (row.Units.length > 0) {
        if (row.IsMain) {
          // row.Quantity2= (row.Quantity / Number(row.Rate)).toFixed(5);
          row.Quantity2 = this.getQuantity(row.Quantity / Number(row.Rate))
          if (type === 0) {
            row.Amount = this.setAmount(row.Price, row.Quantity)
          }
        } else {
          row.Quantity2 = this.getQuantity(data * Number(row.Rate))
          if (type === 0) {
            row.Amount = this.setAmount(row.Price, row.Quantity)
          }
        }
      } else {
        row.Quantity2 = row.Quantity
        row.Amount = this.setAmount(row.Price, row.Quantity)
      }
      if (this.data.ProcessingType === '注塑' && type === 0) {
        this.editMouldQua(row)
      }
    },
    compareUnitId(data, row, index) {
      if (row.T === 3) row.T = 1

      this.editT(row)

      let lastIsMain = row.IsMain
      if (data.IsMain) {
        this.tableData[index].IsMain = false
      } else {
        this.tableData[index].IsMain = true
      }
      let findIndex = 0
      if (row.UnitId == row.UnitId2) {
        let num = 0
        num = row.Quantity
        row.Quantity = row.Quantity2
        row.Quantity2 = num

        if (this.tableData[index].IsMain == false) {
          //当前选择的主单位
          findIndex = this.getUnitIndex(2, this.tableData[index].Units)
          this.changeLeftUnitId(index, findIndex)
          // row.ChangeType2 = data.ChangeType;
        } else {
          findIndex = this.getUnitIndex(1, this.tableData[index].Units)
          this.changeLeftUnitId(index, findIndex)
          //  row.ChangeType2 = data.ChangeType;
        }
      } else {
        if (this.tableData[index].IsMain == false) {
          //当前选择的主单位
          findIndex = this.getUnitIndex(2, this.tableData[index].Units)
          this.changeLeftUnitId(index, findIndex)
          //  row.ChangeType2 = data.ChangeType;
        } else {
          findIndex = this.getUnitIndex(1, this.tableData[index].Units)
          this.changeLeftUnitId(index, findIndex, data.Rate)
          // row.ChangeType2 = data.ChangeType;
          if (!lastIsMain) {
            row.Quantity = row.Quantity2
          }
          // row.Quantity2 = (row.Quantity / Number(data.Rate)).toFixed(5);
          row.Quantity2 = this.getQuantity(row.Quantity / Number(data.Rate))
        }
      }
      this.changeQuantity2(this.tableData[index].Quantity2, row, index, 1)

      let val = this.setNumber(Math.abs(row.Amount / row.Quantity))
      row.Price = this.getPrice(val)

      val = this.setNumber(Math.abs(row.Amount / row.Quantity2))
      row.Price2 = this.getPrice(val)
    },
    changeLeftUnitId(index, findIndex, Rate = 0) {
      this.tableData[index].UnitId = this.tableData[index].Units[findIndex].UnitId
      this.tableData[index].SaUnitName = this.tableData[index].Units[findIndex].UnitName
      // this.tableData[index].ChangeType1=this.tableData[index].Units[findIndex].ChangeType

      if (Rate > 0) {
        this.tableData[index].Rate = Rate
      }
    },
    changeQuantity2(data, row, index, type = 0) {
      if (data == '-' || data == '.' || data == '') {
        return
      }
      this.editT(row)
      // if(this.data.MinusEntry){
      //       row.Quantity2=0-row.Quantity2
      //      }else{
      //       row.Quantity2=Math.abs(row.Quantity2)
      //      }
      if (this.data.MinusEntry) {
        row.Quantity > 0 ? (row.Quantity = 0 - row.Quantity) : row.Quantity
        row.Quantity2 > 0 ? (row.Quantity2 = 0 - row.Quantity2) : row.Quantity2
        data = data > 0 ? 0 - data : data
      } else {
        row.Quantity = Math.abs(row.Quantity)
        row.Quantity2 = Math.abs(row.Quantity2)
        data = Math.abs(data)
      }
      if (row.T === 3) row.T = 1
      if (row.IsMain == false) {
        if (row.ChangeType == 1 && row.Quantity != 0) {
          row.Rate = Math.abs(Number(data / row.Quantity)).toFixed(5)
          if (type === 0) {
            let val = this.setNumber(Math.abs(row.Amount / data))
            row.Price2 = this.getPrice(val)
          }
        } else {
          console.log('数量1=数量2/换算率')
          // row.Quantity=Number(data/row.Rate).toFixed(5);
          if (row.Quantity === 0) {
            row.Quantity = this.getQuantity(data * row.Rate)
          } else {
            row.Quantity = this.getQuantity(data / row.Rate)
          }
          if (type === 0) {
            row.Amount = this.setAmount(row.Price2, row.Quantity2)
          }
        }
      } else {
        if (row.ChangeType == 1 && row.Quantity != 0) {
          row.Rate = Math.abs(Number(row.Quantity / data)).toFixed(5)
          if (type === 0) {
            let val = this.setNumber(Math.abs(row.Amount / data))
            row.Price2 = this.getPrice(val)
          }
        } else {
          console.log('数量1=数量2*换算率')
          // row.Quantity=Number(data*row.Rate).toFixed(5);
          row.Quantity = this.getQuantity(data * row.Rate)
          if (type === 0) {
            row.Amount = this.setAmount(row.Price2, row.Quantity2)
          }
        }
      }
    },
    changePrice(val, row) {
      this.editT(row)

      val = this.setNumber(val)
      row.Price = this.getPrice(val)
      row.Amount = this.setAmount(row.Price, row.Quantity)

      if (row.UnitId2 && row.Quantity2 !== 0) {
        row.Price2 = this.getPrice(row.Amount / row.Quantity2)
      }
    },
    changePrice2(val, row) {
      this.editT(row)

      val = this.setNumber(val)
      row.Price2 = this.getPrice(val)

      row.Amount = this.setAmount(row.Price2, row.Quantity2)
      if (row.Quantity !== 0) {
        row.Price = this.getPrice(row.Amount / row.Quantity)
      }
    },
    setAmount(p, q) {
      return Number((p * q).toFixed(5))
    },
    changeAmount(val, row) {
      this.editT(row)

      if (this.data.MinusEntry) {
        val = val > 0 ? 0 - val : val
      } else {
        val = Math.abs(val)
      }
      row.Amount = this.setNumber(val)

      if (row.Quantity !== 0) {
        row.Price = this.getPrice(Math.abs(row.Amount / row.Quantity))
      } else {
        this.$message({ type: 'warning', message: '实收数量不能为0' })
        row.Amount = 0
        return
      }

      if (row.Units.length > 0) {
        if (row.Quantity2 !== 0) {
          row.Price2 = this.getPrice(Math.abs(row.Amount / row.Quantity2))
        } else {
          this.$message({ type: 'warning', message: '实收数量2不能为0' })
          row.Amount = 0
          return
        }
      }
    },
    editT(row) {
      if (row.T !== 0) {
        row.T = 1
      }
    },
    RateChange(data, row, index) {
      if (data < 0 || data == '') return
      this.editT(row)
      row.Rate = data
      row.Rate = Number(row.Rate).toFixed(5)
      // this.changeQuantity(this.tableData[index].Quantity,row,index)
      if (row.IsMain) {
        // row.Quantity2 = (row.Quantity / Number(data)).toFixed(5);
        row.Quantity2 = this.getQuantity(row.Quantity / Number(data))
      } else {
        // row.Quantity = (row.Quantity2 / Number(data)).toFixed(5);
        row.Quantity = this.getQuantity(row.Quantity2 / Number(data))
      }

      let val = this.setNumber(row.Amount / row.Quantity)
      row.Price = this.getPrice(val)

      val = this.setNumber(row.Amount / row.Quantity2)
      row.Price2 = this.getPrice(val)
    },
    changeMouldQuantity(val, row) {
      this.editT(row)
      val = this.setNumber(val)
      row.Quantity = parseFloat(this.getQuantity(parseFloat(val)))
      row.Amount = Number(this.setAmount(row.Price, row.Quantity).toFixed(5))

      // 按比例修改对应的胶件
      let mouldId = row.MouldId
      this.tableData.forEach((item, index) => {
        if (item.MouldId === mouldId) {
          item.Quantity = Math.ceil(row.Quantity * item.mouldRate)

          this.changeQuantity(item.Quantity, item, index, 5)
        }
      })
    },
    changeMouldPrice(val, row) {
      this.editT(row)
      val = this.setNumber(val)
      row.Price = parseFloat(this.getPrice(parseFloat(val)))
      row.Amount = Number(this.setAmount(row.Price, row.Quantity).toFixed(5))
      console.log('222')
    },
    changeMouldAmount(val, row) {
      this.editT(row)
      val = this.setNumber(val)
      row.Amount = Number(val.toFixed(5))
      if (row.Quantity !== 0) {
        row.Price = this.getPrice(row.Amount / row.Quantity)
      }
    },
    changeColor(val, row) {
      this.editT(row)

    row.colorNo = ''
      let item = row.Colors.filter(item => {
        return item.ColorId === val
      })[0]
      row.ColorNo = item.ColorNo
      row.ColorName = item.ColorName
      if (row.ProductId > 0) {
        row.Barcode = row.ProductNo + '*' + (row.ColorNo || 0) + '*' + (row.PropertyNo || 0)
      }
    },
    changeProperty(val, row) {
      this.editT(row)

       row.PropertyNo = ''
      let item = this.propertyList.filter(item => {
        return item.PropertyId === val
      })[0]
      row.PropertyNo = item.PropertyNo
      row.PropertyName = item.PropertyName
      if (row.ProductId > 0) {
        row.Barcode = row.ProductNo + '*' + (row.ColorNo || 0) + '*' + (row.PropertyNo || 0)
      }
    },
    changeWarehouse(val, row) {
      this.editT(row)

      let item = this.warehouseList.filter(item => {
        return item.value === val
      })[0]

      row.WarehouseName = item.label
    },
    changeUnit(val, row) {
      if (row.T !== 0) {
        row.T = 1
      }

      let item = row.Units.filter(item => {
        return item.UnitId === val
      })[0]

      row.UnitName = item.UnitName
    },
    onSelect_MouldName(e, row) {
      this.editT(row)
      if (this.data.WarehouseId == 0 || this.data.WarehouseId == null) return this.$message.warning('请先选择仓库')
      row.MouldName = e.MouldName
      row.MouldId = e.MouldId
      row.MouldNo = e.MouldNo
      row.PerNetWeight = e.PerNetWeight
      row.Price = e.Price

      this.setProduct(e.MouldId, row)
    },
    resetFun() {
      this.pageParams.pageIndex = 1
      this.DAccount = this.initDAccount
      this.listTotal = this.initTotal
    },
    currentPage({ val, text1 }, row) {
      this.pageParams.pageIndex = val
      this.pdApi.list({ pageIndex: val, pageSize: 7, Status: 1, ProductName: text1 }).then(res => {
        if (res.Code == 0) {
          this.DAccount = res.Data
          this.listTotal = res.Count
        }
      })
    },
    inputText(text, row) {
      row.ProductName = text
      this.pdApi.list({ pageIndex: 1, pageSize: 7, ProductName: text, Status: 1 }).then(res => {
        if (res.Code == 0) {
          this.DAccount = res.Data

          this.listTotal = res.Count
        }
      })
    },
    mresetFun() {
      this.mpageParams.pageIndex = 1
      this.mDAccount = this.minitDAccount
      this.mlistTotal = this.minitTotal
    },
    mcurrentPage({ val, text1 }, row) {
      this.mpageParams.pageIndex = val
      this.mouldApi.list({ pageIndex: val, pageSize: 7, MouldName: text1, Statuses: [1, 2] }).then(res => {
        if (res.Code == 0) {
          this.mDAccount = res.Data
          this.mlistTotal = res.Count
        }
      })
    },
    minputText(text, row) {
      row.MouldName = text
      this.mouldApi.list({ pageIndex: 1, pageSize: 7, MouldName: text, Statuses: [1, 2] }).then(res => {
        if (res.Code == 0) {
          this.mDAccount = res.Data

          this.mlistTotal = res.Count
        }
      })
    },
    changeStage(value) {
      this.tableType = value // 1 模具列表

      if (this.tableType !== '注塑' && this.tableData.length === 0) {
        this.newLine_pro()
      }
      this.processList.forEach(item => {
        if (item.ItemText == value) {
          this.data.ItemText = item.ItemValue
          this.Stage = this.data.ItemText - 1
        }
      })
    },
    tableRowClassName({ row, rowIndex }) {
      row.index = rowIndex
    },
    async openPage() {
      const res = await this.sourceTypeApi.info('委外入库单')
      this.OrderType = res.SourceTypeId
      let that = await this.$refs.editDialog.open()
      that.get_data({ Stage: this.data.ItemText - 1, ProductionType: 1 })
    },
    del(row, index) {
      this.$confirm('确认删除这条数据吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(res => {
        // 注塑时，删除数据时，下删子列表数据
        if (row.childData) {
          if (row.childData.length > 0) {
            row.childData.forEach(item => {
              if (item.T !== 0) {
                item.T = 2
                item.PropertyId = item.PropertyId ? item.PropertyId : 0
                item.ColorId = item.ColorId ? item.ColorId : 0
                item.WarehouseId = item.WarehouseId ? item.WarehouseId : 0
                item.UnitId = item.UnitId ? item.UnitId : 0
                this.delTableData.push(item)
              }

              this.tableData.splice(index, 1)

              if (this.tableData.length === 0) {
                this.newLine_pro()
              }
            })
          }
        }
        if (row.T !== 0) {
          row.T = 2
          this.delMouldData.push(row)
        }
        this.mouldData.splice(index, 1)

        if (this.mouldData.length === 0) {
          this.newLine()
        }

        let pds =
          row.Rubbers &&
          row.Rubbers.map(item => {
            return item.ProductId
          })

        pds && this.del_pro(pds)
      })
    },
    del_pro1(row, index) {
      this.$confirm('确认删除这条数据吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(res => {
        if (row.T !== 0) {
          row.T = 2
          row.PropertyId = row.PropertyId ? row.PropertyId : 0
          row.ColorId = row.ColorId ? row.ColorId : 0
          row.WarehouseId = row.WarehouseId ? row.WarehouseId : 0
          row.UnitId = row.UnitId ? row.UnitId : 0
          this.delTableData.push(row)
        }

        this.tableData.splice(index, 1)

        let list = this.tableData.filter(item => {
          return item.MouldId === row.MouldId
        })
        if (list.length === 0) {
          const index = this.mouldData.findIndex(i => i.MouldId === row.MouldId)
          if (index !== -1) {
            let mould = this.mouldData.find(item => item.MouldId === row.MouldId)
            if (mould.T !== 0) {
              mould.T = 2
              this.delMouldData.push(mould)
            }
            this.mouldData.splice(index, 1)
          }
        }

        if (this.tableData.length === 0) {
          this.newLine_pro()
        }
      })
    },
    del_pro(pds) {
      for (let i = 0; i < pds.length; ++i) {
        let pItem = this.tableData.filter(item => {
          return item.ProductId === pds[i]
        })[0]

        console.log('pItem', pItem)

        if (pItem.T !== 0) {
          pItem.T = 2
          pItem.PropertyId = pItem.PropertyId ? pItem.PropertyId : 0
          pItem.ColorId = pItem.ColorId ? pItem.ColorId : 0
          pItem.WarehouseId = pItem.WarehouseId ? pItem.WarehouseId : 0
          pItem.UnitId = pItem.UnitId ? pItem.UnitId : 0
          this.delTableData.push(pItem)
        }

        let index = this.tableData.findIndex(item => {
          return item.ProductId === pds[i]
        })
        this.tableData.splice(index, 1)
      }

      console.log('this.delTableData', this.delTableData)
    },
    newLine() {
      let o = {
        T: 0,
        DocId: 0,
        DocMouldId: 0,
        WorkDocNo: '',
        MouldId: 0,
        MouldNo: '',
        MouldName: '',
        PerNetWeight: '',
        Quantity: null,
        Price: null,
        Amount: null,
        SourceId: 0,
        SourceNo: '',
        SourceDtsId: 0,
        SourceType: 0,
        AnswerQuantity: null,
        TotalInQuantity: null,
        BatchNumber: '',
        BatchStartDate: this.$commonJs.getToday()
      }

      this.mouldData.push(o)
    },
    newLine_pro() {
      let o = {
        T: 0,
        WorkDocNo: '',
        WarehouseId: '',
        ProductName: '',
        ProductNo: '',
        ProductSpec: '',
        PropertyId: null,
        PropertyName: '',
        Colors: [],
        ColorId: null,
        ColorName: '',
        UnitId: null,
        UnitName: '',
        Units: [],
        Quantity: null,
        Price: null,
        Amount: null,
        SourceId: 0,
        SourceNo: '',
        SourceDtsId: 0,
        SourceType: 0,
        ProductionType: 1,
        ProductionDpId: this.data.TradeUnitId,

        UnitId2: null,
        UnitName2: '',
        Quantity2: null,
        Price2: null,
        Rate: null,
        Remark: '',
        AnswerQuantity: null,
        TotalInQuantity: null,
        BatchNumber: '',
        BatchStartDate: this.$commonJs.getToday()
      }

      this.tableData.push(o)
    },
    add_pro(row, column) {
      if (column.label === '操作' || this.Status === 2) {
        return
      }
      if (row.index === this.tableData.length - 1) {
        this.newLine_pro()
      }
    },
    // add_pro(row, column) {
    //   if (
    //     column.label === "操作" ||
    //     this.tableType === "注塑" ||
    //     this.Status === 2
    //   ) {
    //     return;
    //   }
    //   if (row.index === this.tableData.length - 1) {
    //     this.newLine_pro();
    //   }
    // },
    getMouldData(data) {
      let mouldData = []
      data = data.filter(item => {
        return item.MouldId !== 0
      })

      data.forEach(item => {
        let { T, DocId = 0, DocMouldId = 0, Amount, MouldId, MouldName, PerNetWeight, MouldNo, Price, Quantity, WorkDocNo, SourceId, SourceNo, SourceDtsId, SourceType } = item

        let o = {
          T,
          DocId,
          DocMouldId,
          Amount,
          MouldId,
          MouldName,
          MouldNo,
          Price,
          Quantity,
          WorkDocNo,
          PerNetWeight,
          SourceId,
          SourceNo,
          SourceDtsId,
          SourceType
        }

        mouldData.push(o)
      })

      return mouldData
    },
    getProductsData(data) {
      let Products = []
      data.forEach(item => {
        let {
          T,
          DocId = 0,
          DocProductId = 0,
          ProductId,
          Amount,
          ColorId,
          ColorName,
          Colors,
          MouldId,
          Price,
          ProductName,
          ProductNo,
          ProductSpec,
          PropertyId,
          PropertyName,
          Quantity,
          UnitId,
          UnitName,
          Units,
          WarehouseId,
          WorkDocNo,
          WarehouseName,
          SourceId,
          SourceNo,
          SourceDtsId,
          SourceType,
          ProductionType,
          ProductionDpId,

          UnitId2,
          UnitName2,
          Quantity2,
          Price2,
          Rate,
          Remark,
          BatchNumber,
          BatchStartDate,
          Grammage,
          PackingQuantity,
          PackingSpeciId,
          RealPackingNumber,
          Barcode
        } = item

        PropertyId = PropertyId ? PropertyId : 0
        ColorId = ColorId ? ColorId : 0
        WarehouseId = WarehouseId ? WarehouseId : 0
        UnitId = UnitId ? UnitId : 0
        Price = Price ?? 0
        Amount = Amount ?? 0
        MouldId = MouldId ?? 0

        let o = {
          T,
          DocId,
          DocProductId,
          ProductId,
          Amount,
          ColorId,
          ColorName,
          Colors,
          Price,
          ProductName,
          ProductNo,
          ProductSpec,
          PropertyId,
          PropertyName,
          Quantity,
          UnitId,
          UnitName,
          Units,
          WarehouseId,
          WorkDocNo,
          WarehouseName,
          SourceId,
          SourceNo,
          SourceDtsId,
          SourceType,
          ProductionType,
          ProductionDpId,
          MouldId,

          UnitId2,
          UnitName2,
          Quantity2,
          Price2,
          Rate,
          Remark,
          BatchNumber,
          BatchStartDate,
          Grammage,
          PackingQuantity,
          PackingSpeciId,
          RealPackingNumber,
          Barcode
        }

        Products.push(o)
      })

      return Products
    },
    save(type = 0) {
      //验证表单是否填写 TradeUnitId
      let yanzheng = ['DocDate', 'DocNo', 'BusinessTypeId', 'WarehouseId', 'ProcessingType', 'WorkShopId', 'EmpId', 'TradeUnitId']
      for (let key in this.data) {
        if (yanzheng.indexOf(key) !== -1 && !this.data[key]) {
          this.$message({ type: 'warning', message: '表单未填写完整' })
          return
        }
      }
      for (var i = 0; i < this.tableData.length; i++) {
        var e = this.tableData[i]
        if (e.Units && e.Units.length && !e.UnitId) {
          this.$message({ type: 'warning', message: '请选择计量单位' })
          return
        }
        // if(!(e.Quantity > 0)) {
        //   this.$message({type: 'warning', message: '请填写正确的数量'});
        //   return;
        // }
      }

      let Moulds = this.getMouldData(this.mouldData)
      let Products = this.getProductsData(this.tableData)
      if (Products.length > 0 && Products[0].ProductName != '') {
      } else {
        this.$message({ type: 'warning', message: '明细列表不能为空' })
        return
      }
      Moulds = Moulds.filter(item => {
        return item.T != null && item.MouldId !== 0 && item.MouldId != null
      })

      Moulds = Moulds.concat(this.delMouldData)

      Products = Products.filter(item => {
        return item.T != null && item.ProductId !== 0 && item.ProductId != null
      })

      Products = Products.concat(this.delTableData)

      Products = Products.map(item => {
        item.ProductionDpId = this.data.TradeUnitId
        item.ProductionType = 1
        return item
      })
      // Products.forEach(item=>{
      //   if(item.Quantity=='')item.Quantity=0
      //   if(item.Price=='')item.Price=0
      // })
      Moulds.forEach(item => {
        if (item.Quantity == '') item.Quantity = 0
        if (item.Price == '') item.Price = 0
      })

      var btId = 0
      var obj = this.businessTypeList.find(x => x.BusinessType == '委外退库')
      if (obj) btId = obj.BusinessTypeId

      let ProductsLength = Products.length
      for (let i = 0; i < ProductsLength; ++i) {
        if (this.data.BusinessTypeId == btId && btId) {
          if (Products[i].Amount > 0) {
            this.$message({ type: 'warning', message: '金额不能大于0' })
            return
          }
        } else {
          if (Products[i].Amount < 0) {
            this.$message({ type: 'warning', message: '金额不能小于0' })
            return
          }
        }
        if (Products[i].UseColor && Products[i].ColorId === 0) {
          this.$message.error(`存货${Products[i].ProductName}未填写颜色`)
          return
        }
        // if (Products[i].UseProcess && Products[i].PropertyId === 0) {
        //   this.$message.error(`存货${Products[i].ProductName}未填写属性`);
        //   return;
        // }
        // if(Products[i].Quantity === 0 || Products[i].Price === 0){
        //    this.$message({type: 'warning', message: '存货数量或价格不能为0'})
        //   return
        // }
      }

      // let MouldsLength = Moulds.length;
      // if(this.data.ProcessingType=='注塑'){
      //   for(let i = 0; i < MouldsLength; ++i){
      //   if(Moulds[i].Quantity === 0 || Moulds[i].Price === 0){
      //      this.$message({type: 'warning', message: '模具数量或价格不能为0'})
      //     return
      //   }
      // }
      // }

      let o = {
        Moulds,
        Products,
        ...this.data
      }
      console.log('o', o)

      this.api.save(o).then(res => {
        if (res.Code === 0) {
          if (this.viewType === 'create') {
            this.data.DocId = res.Data
          }
          if (type !== 1) {
            this.$message.success(res.Msg)
          }
          this.isSave = true

          this.api.info(this.data.DocId).then(res => {
            if (res.Code === 0) {
              this.$route.params.data = res.Data
              if (type === 1) {
                this.reView1()
              } else {
                this.editInit(res.Data)
              }
            }
          })
        } else {
          this.$message({ type: 'warning', message: res.Msg })
        }
      })
    },
    newAdd() {
      if (!this.isSave) {
        this.$message({ type: 'warning', message: '请先进行保存再操作' })
        return
      } else {
        Object.assign(this.$data, this.$options.data.call(this))
        this.getPreviewNo()
        this.data.EmpId = this.$commonJs.empId()
        this.data.EmpName = this.$commonJs.userName()
        this.$route.params.type = 'create'
        this.viewType = 'create'
        this.init()
        this.isSave = false
      }
    },
    handleDelete() {
      let id = this.data.DocId
      this.$confirm('确定删除?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(res => {
        this.api.delete(id).then(res => {
          if (res.Code === 0) {
            this.$message({ type: 'success', message: res.Msg })
            this.newAdd()
            // this.$emit('deleted')
          } else {
            this.$message({ type: 'warning', message: res.Msg })
          }
        })
      })
    },
    async saved({ subList, extraList, TradeUnitId }) {
      this.data.TradeUnitId = TradeUnitId
      console.log('this.data.TradeUnitId', this.data.TradeUnitId)
      extraList = extraList.filter(item => {
        return item.MouldId !== 0
      })
      const res = await this.sourceTypeApi.info('生产工单产品')
      let SourceType = res.SourceTypeId
      let arr = []

      let _MouldId = null
      let _MouldName = ''
      let _Quantity = null
      extraList.forEach(item => {
        if (this.tableType === '注塑') {
          let {
            T,
            DocId = 0,
            DocMouldId = 0,
            Amount,
            MouldId,
            MouldName,
            PerNetWeight,
            MouldNo,
            Price,
            Quantity,
            WorkDocNo,
            SourceId = item.WorkDocId,
            SourceNo = item.WorkDocNo,
            SourceDtsId = item.WorkDocProductId,
            SourceType,
            TotalInQuantity,
            AnswerQuantity
          } = item
          SourceDtsId = item.WorkDocProductId

          Price = Price ?? 0
          Amount = Amount ?? 0

          _MouldId = MouldId
          _MouldName = MouldName
          _Quantity = Quantity

          let o = {
            T,
            DocId,
            DocMouldId,
            Amount,
            MouldId,
            MouldName,
            MouldNo,
            Price,
            Quantity: item.Quantity - item.TotalInQuantity,
            WorkDocNo,
            PerNetWeight,
            SourceId,
            SourceNo,
            SourceDtsId,
            SourceType,
            TotalInQuantity,
            AnswerQuantity
          }
          o.childData = subList || []
          this.mouldData.unshift(o)
        }
      })
      console.log('list', subList)
      subList.forEach(item => {
        let o = {
          T: 0,
          DocId: 0,
          DocProductId: 0,
          WorkDocNo: item.WorkDocNo,
          SiteWarehouseId: null,
          GeneralWarehouseId: null,
          SiteWarehouseName: '',
          GeneralWarehouseName: '',
          ProductId: item.ProductId,
          ProductNo: item.ProductNo,
          ProductName: item.ProductName,
          ProductSpec: item.ProductSpec,
          PropertyId: item.PropertyId || 0,
          PropertyName: item.PropertyName || '',
          UseProcess: item.UseProcess,
          UseColor: item.UseColor,
          ColorId: item.ColorId || 0,
          ColorName: item.ColorName || '',
          Colors: item.Colors || [],
          Units: item.Units || [],
          UnitId: item.UnitId,
          UnitName: item.PdUnitName != null ? item.PdUnitName : item.SkUnitName,
          Quantity: item.Quantity,
          mouldRate: ((item._MouldQuantity ? item._MouldQuantity : _Quantity) / item.Quantity).toFixed(5),
          Price: 0,
          Amount: 0,
          SourceId: item.type === 1 ? item._WorkDocId : item.WorkDocId,
          SourceNo: item.WorkDocNo,
          SourceDtsId: item.type === 1 ? item._WorkDocProductId : item.WorkDocProductId,
          SourceType: SourceType,
          WarehouseId: this.data.WarehouseId,
          WarehouseName: this.data.WarehouseName,
          MouldName: item.MouldName ? item.MouldName : _MouldName,
          MouldId: item.MouldId ? item.MouldId : _MouldId,

          UnitId2: null,
          UnitName2: '',
          Quantity2: 0,
          Price2: 0,
          Rate: 0,
          Grammage: item.Grammage,
          WorkShopId: item.WorkShopId,
          WorkShopName: item.WorkShopName,
          Products: [],
          TotalInQuantity: item.InQuantity,
          AnswerQuantity: item.AnswerQuantity,
          HasGrammage: item.HasGrammage,
          Variable: item.Variable,
          SkUnitId: item.SkUnitId,
          SkUnitName: item.SkUnitName,
          BatchNumber: item.BatchNumber,
          PackingQuantity: null,
          PackingSpeciId: null
        }
        arr.push(o)
      })

      arr.forEach((item, i) => {
        this.workDocApi.info(item.SourceId).then(res1 => {
          if (res1.Code == 0) {
            //PZ240123001
            var extraList = res1.Data.ProductModels
            if (extraList && extraList[0]) {
              let sourceNo = res1.Data.WorkDocNo
              let sourceId = res1.Data.WorkDocId
              let sourceDtsId = extraList[0].WorkDocProductId
              console.log('extraList[0].BomRubbers', extraList[0].BomRubbers)
              //模具对应的存货，用于下拉选择
              item.Products = extraList[0].BomRubbers.map(item1 => {
                item1.type = 1
                item1.InitQuantity = item1.Quantity
                if (this.docType === 1) {
                  item1.Quantity = item1.NeedQuanity - item1.InQuantity
                } else {
                  item1.Quantity = item1.NeedQuanity - item1.DirectInQuantity
                }

                item1.WorkDocNo = sourceNo
                item1.ProcessStage = 0
                item1.UnitId = item1.PdUnitId
                item1.UnitName = item1.PdUnitName
                item1._WorkDocProductId = sourceDtsId
                item1._WorkDocId = sourceId
                return { ...item1 }
              })
            }
          }
        })
        item.isSource = item.SourceNo === '' || item.SourceNo == null ? false : true

        item.UnitType = 0
        item.ChangeType = 0
        // item.Units.forEach(v=>{
        //   if(v.ChangeType==1)item.ChangeType=v.ChangeType
        // })
        if (item.Units.length === 0) {
        } else {
          item.UnitType = 1
          // if (item.UnitId != item.SkUnitId) {
          //     if (item.Units.filter(x => x.IsMain && x.UnitId == item.UnitId).length > 0) {
          //         item.Quantity = item.Quantity / item.Units.find(x => !x.IsMain && x.UnitId == item.SkUnitId).Rate;
          //     } else {
          //         item.Quantity = item.Quantity * item.Units.find(x => !x.IsMain && x.UnitId == item.UnitId).Rate;
          //     }
          //     item.UnitId = item.SkUnitId;
          //     item.UnitName = item.SkUnitName;
          // }
          let index = this.getUnitIndex(3, item.Units, item.UnitId)
          let data = this.getUnitValue(item.Units, index)
          let assistIndex = 0
          let assistData = {}
          item.IsMain = data.IsMain
          item.UnitName = data.UnitName
          // row.ChangeType1 = data.ChangeType;
          item.Units.forEach(item2 => {
            if (item2.ChangeType == 1) item.ChangeType = item2.ChangeType
          })
          if (data.IsMain) {
            assistIndex = this.getUnitIndex(2, item.Units)
            assistData = this.getUnitValue(item.Units, assistIndex)
            item.Rate = assistData.Rate.toFixed(5)
          } else {
            assistIndex = this.getUnitIndex(1, item.Units)
            assistData = this.getUnitValue(item.Units, assistIndex)
            item.Rate = data.Rate.toFixed(5)
          }
          item.UnitId2 = assistData.UnitId
          item.UnitName2 = assistData.UnitName
          // row.ChangeType2 = assistData.ChangeType;
        }

        this.changeQuantity(arr[i].Quantity, item, i, 1)
      })
      if (this.tableData.length && !this.tableData[0].SourceNo) {
        this.data.WarehouseId = arr[0].WarehouseId
      }
      this.tableData.unshift(...arr)
    },
    reView1() {
      let id = this.data.DocId
      this.api.examine(id).then(res => {
        if (res.Code === 0) {
          this.$message({ type: 'success', message: res.Msg })
          this.api.info(this.data.DocId).then(res => {
            if (res.Code === 0) {
              this.$route.params.data = res.Data
              this.editInit(res.Data)
            }
          })
        } else {
          this.$message({ type: 'warning', message: res.Msg })
        }
      })
    },
    reView() {
      this.save(1)
    },
    cancelReView() {
      let id = this.data.DocId
      this.api.cancelExamine(id).then(res => {
        if (res.Code === 0) {
          this.$message({ type: 'success', message: res.Msg })
          this.api.info(this.data.DocId).then(res => {
            if (res.Code === 0) {
              this.$route.params.data = res.Data
              this.editInit(res.Data)
            }
          })
        } else {
          this.$message({ type: 'warning', message: res.Msg })
        }
      })
    },
    /** 打开批号弹框 */
    onOpenBatch(e, row, index) {
      row.BatchNumber = ''
      this.batchPageParams.pageIndex = 1
      let o = {
        IsInOut: 0,
        WarehouseId: row.WarehouseId,
        ProductId: row.ProductId,
        PropertyId: row.PropertyId,
        ColorId: row.colorId,
        pageIndex: 1,
        pageSize: 7
      }
      var params = this.$commonJs.obj.removeNullKey(o)
      this.pdApi.productBatchNumberList(params).then(res => {
        if (res.Code == 0) {
          this.batchList = res.Data.map(item => {
            return {
              ...item,
              BatchStartDate: this.$commonJs.toDateString(item.BatchStartDate),
              ExpireDate: this.$commonJs.toDateString(item.ExpireDate)
            }
          })
          this.batchListTotal = res.Count
        } else {
          this.$message.error(res.Msg)
        }
      })
    },
    /** 选择批号 */
    onSelBatch(e, row, index) {
      if (row.T !== 0) {
        row.T = 1
      }
      if (row.BatchNumber !== e.BatchNumber) {
        row.BatchNumber = e.BatchNumber
      }
    },
    /** 输入批号 */
    inputTextBatch(text, row) {
      if (row.T !== 0) {
        row.T = 1
      }
      row.BatchNumber = text
      //IsInOut 入库-0 出库-1
      let o = {
        IsInOut: 0,
        WarehouseId: row.WarehouseId,
        ProductId: row.ProductId,
        PropertyId: row.PropertyId,
        ColorId: row.colorId,
        BatchNumber: row.BatchNumber,
        pageIndex: 1,
        pageSize: 7
      }
      var params = this.$commonJs.obj.removeNullKey(o)
      this.pdApi.productBatchNumberList(params).then(res => {
        if (res.Code == 0) {
          this.batchList = res.Data.map(item => {
            return {
              ...item,
              BatchStartDate: this.$commonJs.toDateString(item.BatchStartDate),
              ExpireDate: this.$commonJs.toDateString(item.ExpireDate)
            }
          })
          this.batchListTotal = res.Count
        } else {
          this.$message.error(res.Msg)
        }
      })
    },
    /** 批号下一页 */
    currentPageBatch({ val, text1 }, row) {
      this.batchPageParams.pageIndex = val
      let o = {
        IsInOut: 0,
        WarehouseId: row.WarehouseId,
        ProductId: row.ProductId,
        PropertyId: row.PropertyId,
        ColorId: row.colorId,
        ProductName: row.ProductName,
        pageIndex: val,
        pageSize: 7
      }
      var params = this.$commonJs.obj.removeNullKey(o)
      this.pdApi.productBatchNumberList(params).then(res => {
        if (res.Code == 0) {
          this.batchList = res.Data.map(item => {
            return {
              ...item,
              BatchStartDate: this.$commonJs.toDateString(item.BatchStartDate),
              ExpireDate: this.$commonJs.toDateString(item.ExpireDate)
            }
          })
          this.batchListTotal = res.Count
        } else {
          this.$message.error(res.Msg)
        }
      })
    },
    onPrint(row) {
      let newpage = this.$router.resolve({
        path: '/outsourcedwarehousingPrint?id=' + row.DocId
      })
      window.open(newpage.href, '_blank')
    },
    /** 批号起始日期 */
    changeBatchStartDate(row) {
      if (row.T !== 0) {
        row.T = 1
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.dropdown-item {
  padding: 6px;
}

.mtx10 {
  padding: 10px;
}

.flex {
  display: flex;
  .text {
    width: 60px;
  }
}
.space-between {
  justify-content: space-between;
}

.center {
  display: flex;
  justify-content: center;
  align-items: center;
}

.flex1 {
  flex: 1;
}

.mrx18 {
  margin-right: 18px;
}
.span {
  display: inline-block;
  width: 180px;
}
.w180 {
  width: 180px;
}
</style>
